import React, { Component } from "react";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import compose from "lodash.flowright";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";

// GraphQL query
const GET_STUDENT_OMR_DETAILS = gql`
  query ($exam_paper_id: Int!) {
    getOMRStudentResults(exam_paper_id: $exam_paper_id) {
      student_user_exam_id
      name
      mobile
      email
      process_status
      omr_sheet
    }
  }
`;

class LongOMRModal extends Component {
  constructor() {
    super();
    this.state = {
      buttonData: 2,
    };
  }

  // Table columns with hyphen fallback and formatted OMR link
  articlecolumns = [
    {
      dataField: "name",
      text: "Student Name",
      sort: true,
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "email",
      text: "Email Id",
      sort: false,
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "mobile",
      text: "Mobile No",
      sort: false,
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "omr_sheet",
      text: "OMR Sheet",
      formatter: (cell, row, rowIndex) =>
        cell ? (
          <a
            href={cell}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textTransform: "none" }}
          >
            {`OMR - ${rowIndex + 1}`}
          </a>
        ) : (
          "-"
        ),
    },
  ];

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState({ buttonData: 2 }); // Reset on modal open
    }
  }

  handleClick = (buttonId) => {
    this.setState({ buttonData: buttonId });
  };

  render() {
    const { getOmrDetails, ...modalProps } = this.props;
    const { buttonData } = this.state;
    const { loading, error, getOMRStudentResults } = getOmrDetails;


    if (error) {
      alert("Server Error. " + error.message);
      return null;
    }

    // Filter data based on status button
    let filteredData = [];
    if (Array.isArray(getOMRStudentResults)) {
      if (buttonData === 0) {
        filteredData = getOMRStudentResults.filter(
          (item) => item.process_status === 0 || item.process_status === 1
        );
      } else {
        filteredData = getOMRStudentResults.filter(
          (item) => item.process_status === buttonData
        );
      }
    }


    const statusButtons = [
      //   { id: 0, label: "Processing" },
      { id: 2, label: "Uploaded" },
      { id: 3, label: "Error" },
    ];

    return (
      <Modal {...modalProps} size="xl" aria-labelledby="example-modal-sizes-title-lg">
        <Modal.Header closeButton>
          <Modal.Title className="modal-title p">Detail view of OMR</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{
          width: "100%",
          height: filteredData.length > 0 ? "500px" : "auto",
          overflow: "auto",
          backgroundColor: "#dee2e6",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}>
          <div className="longomr-btn d-flex mt-2">
            {statusButtons.map((btn) => (
              <Button
                key={btn.id}
                className="ml-2"
                onClick={() => this.handleClick(btn.id)}
                style={
                  buttonData === btn.id
                    ? {
                      background: "#213046",
                      border: "none",
                      color: "white",
                    }
                    : {
                      background: "white",
                      color: "black",
                      border: "1px solid gray",
                    }
                }
              >
                {btn.label}
              </Button>
            ))}
          </div>

          {/* Table or Spinner */}
          {loading ? (
            <Container>
              <Row className="my-2">
                <Col className="text-center">
                  <div className="spinner-border text-primary loading-img-center"></div>
                </Col>
              </Row>
            </Container>
          ) : (
            <>
              {
                filteredData.length > 0 ? (
                  <CardLessDataTableWithSearch
                    parentData={filteredData}
                    particlecolumns={this.articlecolumns}
                    name="hostel_attendance"
                  />
                ) : (
                  <div className="text-center text-success mb-3 h5">No Data Found</div>
                )
              }
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

// GraphQL HOC export
export default compose(
  graphql(GET_STUDENT_OMR_DETAILS, {
    options: (props) => ({
      variables: {
        exam_paper_id: props?.stateData?.paperId || 0,
      },
    }),
    name: "getOmrDetails",
  })
)(LongOMRModal);
